<template>
  <div class="shopping">
    <div class="shopping_content">
      <div class="header">
        <div class="search">
          <div class="lang">
            <el-input placeholder="请输入搜索的商品" v-model="parm.productName">
              <template slot="append">
                <el-button
                    type="primary"
                    icon="el-icon-search"
                    style="border-radius: 0"
                    @click="goSearch"
                >搜索
                </el-button
                >
              </template>
            </el-input>
          </div>
        </div>
        <div class="header_banner">

          <el-carousel height="300px">
            <el-carousel-item v-for="(item, index) in adLists" :key="index">
              <img
                  :src="item.picSrc"
                  alt
                  :title="item.adName"
                  @click="goRouter(item.picUrl)"
                  class="err_image cursorP"
              />
            </el-carousel-item>
          </el-carousel>
        </div>
        <div class="tab flex">
          <el-radio-group v-model="parm.qydjCpfl1" class="world">
            <ul class="tab_a flex">
              <li  @click="tabs('', '0')">
                <el-radio class="style_radio" label>新品</el-radio>
              </li>
              <li
                  v-for="(n, index) in tab"
                  :key="index"
                  :class="{ active: active == index + 1 }"
                  @click="productChilds(n.children)"
              >
                <el-radio :label="n.value" class="style_radio">{{
                    n.label
                  }}
                </el-radio>
              </li>
            </ul>
            <el-collapse-transition>
              <el-radio-group
                  v-model="parm.qydjCpfl2"
                  v-show="show"
                  class="collapse"
              >
                <ul class="bottom flex flex-wrap childs" ref="getHeight">
                  <li>
                    <el-radio label>不限</el-radio>
                  </li>
                  <li v-for="(m, s) in productChild" :key="s">
                    <el-radio :label="m.value">{{ m.label }}</el-radio>
                  </li>
                </ul>
              </el-radio-group>
            </el-collapse-transition>
          </el-radio-group>
        </div>
      </div>
      <!-- 瀑布流 -->
      <div class="content">
        <waterfall
            :col="col"
            :data="data"
            :width="itemWidth"
            :gutterWidth="gutterWidth"
            id="vueWaterfall"
        >
          <template>
            <div
                class="box"
                v-for="item in data"
                :key="item.index"
                @click="detail(item.id)"
            >
              <img
                  v-lazy="item.productImage"
                  :alt="item.productName"
                  class="err_image"
              />
              <h3 class="line_clamp2">{{ item.productName }}</h3>
              <p class="money">
                <span>￥</span>
                <span v-if="item.productPrice">{{ item.productPrice }}</span>
                <span v-else>面议</span>
              </p>
            </div>
          </template>
        </waterfall>
        <status
            type="post"
            des="暂无售卖中商品~"
            v-if="this.data == null || this.data.length <= 0"
        ></status>
        <div
            v-loading="loading"
            element-loading-text="加载中"
            element-loading-spinner="el-icon-loading"
        ></div>
      </div>
    </div>
    <!--    <div class="pages">-->
    <!--      <el-pagination background class="work_pagination" @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page.sync="parm.pageNum" :page-size="parm.pageSize" prev-text="上一页" next-text="下一页" layout="prev, pager, next, total, jumper" :total="parm.total"></el-pagination>-->
    <!--    </div>-->
  </div>
</template>

<script>
export default {
  name: "index",
  data() {
    return {
      search: "",
      active: 0,
      show: false,
      loading: false,
      tab: [],
      childTab: [],
      itemWidth: 230,
      gutterWidth: 10,
      data: [],
      col: 5,
      adLists: [],
      productChild: [],
      parm: {
        productName: "",
        qydjCpfl1: "",
        qydjCpfl2:'',
        pageNum: 0,
        pageSize: 50,
        total:0
      },
    };
  },
  methods: {
    // 去详情
    detail(ids) {
      const {href} = this.$router.resolve({
        path: "/shoppingMall/detail",
        query: {
          id: ids,
        },
      });
      window.open(href, "_blank");
    },
    goSearch() {
      this.parm.qydjCpfl1 = '';
      this.parm.qydjCpfl2 = '';
      this.data = [];
      this.getProductList();
    },
    getProductList() {
      let that = this;
      this.loading = true;
      that.$axios.post('/api/app-jycy-henan/henan/products/list', that.parm)
          .then((result) => {
            if (result.data.success) {
              this.loading = false;
              // if (result.data.data.records.length <= 0){
              //   return  window.removeEventListener("scroll", this.scrolls);
              // }
              // TODO 数组拼接
              that.data = that.data.concat(result.data.data.records);
              this.parm.total = result.data.data.total;
            } else {
              console.log("error");
              this.loading = false;
            }
          })
          .catch((e) => {
            this.loading = false;
          });
    },

    getProductCategoryList() {
      let arr = [];
      this.$axios.get('/api/app-jycy-sysdict/commonDictValue',{
            dictCode: "product_fir",
            maxLevel: 2,
          })
          .then((result) => {
            arr = result.data.data;
            this.tab = arr;
          });
    },
    getad() {
      this.$api
          .adApi({classId: "1348538506839150592"})
          .then((ref) => {
            this.adLists = ref.data.data;
          });
    },
    productChilds(items, value) {
      this.productChild = items;
      this.show = true;
    },
    //进入搜索页面
    goRouter() {
      const {href} = this.$router.resolve({
        path: "/shopping/search",
        query: {
          productName: this.parm.productName,
        },
      });

      window.open(href, "_blank");
    },
    tabs(code, index) {
      let that = this;
      that.active = index;
      that.parm.qydjCpfl1 = code;
      that.parm.qydjCpfl2 = '';
      if (index === "0") {
        this.show = false;
      }
    },
    scrolls(scrollData) {
      // var w = document.getElementById("vueWaterfall");
      var scroll =
          document.documentElement.scrollTop || document.body.scrollTop;
      // console.log(scroll + window.innerHeight, document.body.clientHeight);
      if (scroll + window.innerHeight >= document.body.clientHeight) {
        this.parm.pageNum ++;
        this.parm.pageSize = 16;
        setTimeout(() => {
          this.getProductList();
          this.loading = false;
        }, 500);
      }else{
        window.addEventListener("scroll", this.scrolls);
      }
    },
    handleSizeChange(val) {},
    handleCurrentChange: function (val) {
      this.parm.pageNum = val
      this.getProductList()
    },
  },

  created() {
    // window.addEventListener("scroll", this.scrolls);
    this.getad();
    this.getProductList();
    this.getProductCategoryList();
  },
};
</script>
<style scoped lang="less">
@import "~assets/henan/shopping";

/deep/ .world.el-radio-group .el-radio .el-radio__label {
  font-size: 18px;
}

/deep/ .world.el-radio-group .is-checked .el-radio__label {
  color: #00924B;
  background-color: #ffffff;
  font-weight: 600;
}

/deep/ .world.el-radio-group .is-checked {
  background-color: #ffffff;
  position: relative;
}

/deep/ .el-radio-group {
  .flex-wrap {
    background-color: rgba(25, 137, 203, 0.1);
    border-radius: 4px;
  }
}

/deep/ .el-input {
  .el-input__inner {
    height: 40px;
    font-size: 16px;
    padding-left: 32px;
  }

  .el-input-group__append {
    border: none;

    .el-button {
      width: 100px;
      height: 40px;
      font-size: 18px;
      color: white;
      background: #00924b;
      border-radius: 0px 4px 4px 0px;
    }
  }
}
</style>
